import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import "react-multi-carousel/lib/styles.css";
import List from "./List";
import { BiChevronDown } from "react-icons/bi";
import { useAchievements } from "../../api/useAchievements";
import { FilterDropdown } from "../filterDropdown";
import clsx from "clsx";
const filters = [
  {
    key: "All Time",
    value: "alltime",
  },
  {
    key: "Monthly",
    value: "monthly",
  },
  {
    key: "Weekly",
    value: "weekly",
  },
  {
    key: "Daily",
    value: "daily",
  },
];

function Board({ campaign_id }) {
  const [type, setType] = useState(filters[0]);
  // const hasFetched = useRef(false);
  const { getLeadboard, loadingBoard, leaderboardData, campaignLeaderboard } =
    useAchievements();
  const stableCampaignId = useRef(null);

  useEffect(() => {
    if (campaign_id) {
      stableCampaignId.current = campaign_id;
    }
  }, [campaign_id]);

  useEffect(() => {
    if (!type?.value) return;
    getLeadboard(type.value, stableCampaignId.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, campaign_id]);

  return (
    <div className="w-full relative">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2, delay: 0.4 }}
      >
        <div>
          <div className="px-4 flex items-center gap-3 mt-5 mb-7">
            <p className="text-sm  font-medium text-[#00000080]">Filters:</p>
            <FilterDropdown
              options={filters}
              selectedOption={type}
              setSelectedOption={setType}
              selectedOptionClass={clsx(
                "rmc_select_selected !rounded-none",
                type?.value ? "bg-[#2741d6] !text-white" : "",
              )}
              selectedClass="bg-white !text-black"
              dropdownClass="rmc_select_dropdown text-xs !bg-white"
              optionsClass="rmc_select_options !text-black hover:bg-[#2741d6] hover:!text-[#ffff]"
              trailingIcon={
                <BiChevronDown
                  size={16}
                  className="text-[#0000004D] transition-transform duration-200"
                />
              }
            />
          </div>

          <List
            data={campaign_id ? campaignLeaderboard : leaderboardData}
            isLoading={loadingBoard}
          />
        </div>
      </motion.div>
    </div>
  );
}

export default Board;
